/** Product tags for which the application has a service detail page. */
export const SUPPORTED_PRODUCT_TAGS: ReadonlySet<string> = new Set([
  "FW",
  "L2VPN",
  "L3VPN",
  "IPBGP",
  "IPS",
  "LP",
  "LR",
  "SP",
  "SPNL",
  "MSC",
  "MSCNL",
  "AGGSP",
  "AGGSPNL",
  "IRBSP",
]);

export function isSupportedProductTag(tag: string | null | undefined): boolean {
  return !!tag && SUPPORTED_PRODUCT_TAGS.has(tag);
}
